var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/ResetPassword/index.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import Wizard from 'Components/wizard';
import WizardMainContainer from 'Components/wizard/WizardMainContainer';
import ResetPasswordLinkNotValid from './error/ResetPasswordLinkNotValid';
import ResetPasswordFirstStep from './steps/ResetPasswordFirstStep';
import ResetPasswordSecondStep from './steps/ResetPasswordSecondStep';
const ResetPassword = () => {
  const [showTokenExpirationError, setShowTokenExpirationError] = useState(false);
  const makeSteps = useMemo(() => {
    return [{
      component: ResetPasswordFirstStep,
      componentName: 'ResetPasswordFirstStep'
    }, {
      component: ResetPasswordSecondStep,
      componentName: 'ResetPasswordSecondStep'
    }];
  }, []);
  const handleTokenExpirationError = useCallback(() => {
    setShowTokenExpirationError(true);
  }, []);
  if (showTokenExpirationError) {
    return /*#__PURE__*/React.createElement(ResetPasswordLinkNotValid, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(WizardMainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Wizard, {
    steps: makeSteps,
    handleTokenExpirationError: handleTokenExpirationError,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  })));
};
export default ResetPassword;